import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import ServiceCategoryNavbar from "./ServiceCategoryNavbar";

const Category = () => {
  const [parentId, setParentId] = useState("");
  const [categories, setCategories] = useState([]);
  const [titles, setTitles] = useState([""]); // Array of titles

  useEffect(() => {
    axios
      .get(`${baseurl}getAllServiceCategories`)
      .then((res) => {
        setCategories(res.data.data || []);
      })
      .catch((err) => {
        console.error("Fetch categories error:", err);
      });
  }, []);

  const generateSlug = (text) => {
    return text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");
  };

  // Add new input field
  const addTitleField = () => {
    setTitles([...titles, ""]);
  };

  // Remove input field
  const removeTitleField = (index) => {
    const newTitles = [...titles];
    newTitles.splice(index, 1);
    setTitles(newTitles);
  };

  // Update input field
  const handleTitleChange = (index, value) => {
    const newTitles = [...titles];
    newTitles[index] = value;
    setTitles(newTitles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!parentId) {
      Swal.fire("Error", "Please select a parent category", "error");
      return;
    }

    try {
      // Send each title to backend
      const promises = titles
        .filter((t) => t.trim() !== "")
        .map((title) => {
          const payload = {
            service_title: title,
            is_parent: null,
            has_service: false,
            slug: generateSlug(title),
            parent_id: parentId || null,
          };
          return axios.post(`${baseurl}addServiceCategory`, payload);
        });

      await Promise.all(promises);
      Swal.fire("Success", "All categories added!", "success").then(() =>
        window.location.reload()
      );
    } catch (err) {
      console.error("Submit error:", err);
      Swal.fire("Error", "Failed to add categories", "error");
    }
  };

  // Filter child categories of selected parent
  const childCategories = categories.filter(
    (cat) => cat.parent_id === parseInt(parentId)
  );

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <ServiceCategoryNavbar />

          <div className="crd1 p-4 shadow-sm rounded bg-white">
            <h4 className="mb-3">Add Multiple Service Categories</h4>

            <form onSubmit={handleSubmit}>
              {/* Parent Category Selection */}
              <div className="mb-3">
                <label className="form-label">What We Do</label>
                <select
                  className="form-select"
                  required
                  value={parentId}
                  onChange={(e) => setParentId(e.target.value)}
                >
                  <option value="">-- Select --</option>
                  {categories
                    .filter((cat) => cat.parent_id === null)
                    .sort((a, b) =>
                      a.service_title.localeCompare(b.service_title)
                    ) // sort ascending
                    .map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.service_title}
                      </option>
                    ))}
                </select>
              </div>

              {/* Show existing categories under selected parent */}
              {parentId && (
                <div className="mb-3">
                  <h6>Existing Categories under this:</h6>
                  {childCategories.length > 0 ? (
                    <div className=" card">
                      {childCategories.map((child) => (
                        <div key={child.id} className=" ftg1">
                          {child.service_title}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-muted">No categories found.</p>
                  )}
                </div>
              )}

              {/* Category Titles Inputs */}
              <label className="form-label">Category Titles</label>
              {titles.map((title, index) => (
                <div key={index} className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={`Category Title #${index + 1}`}
                    value={title}
                    required
                    onChange={(e) => handleTitleChange(index, e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => removeTitleField(index)}
                  >
                    Remove
                  </button>
                </div>
              ))}

              <div className="mb-3">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={addTitleField}
                >
                  + Add Another
                </button>
                <button type="submit" className="btn btn-primary">
                  Add All Categories
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;
